import { connect } from 'react-redux';
import  CompressImage from './CompressImage';
import { bindActionCreators } from 'redux';
import  {imageCompressUrl} from 'services/redux/imageCompression/action'

const mapStateToProps = (state) => ({
    prListData: state.siteListingReducer.prListData,
  liveFilterDropDown: state.liveSiteDataReducer.liveFilterDropDown
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      imageCompressUrl
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CompressImage);
